import { useTranslation } from 'react-i18next'
import { isAlcoholNull } from 'utils/validators'

import { Wrapper, Label, Value, Parameter } from './_styles'
import { useProduct } from '../../../_methods'
import { Item, ItemLabel } from '../_styles'

const ChemicalAnalisys = () => {
  const { t } = useTranslation()

  const product = useProduct()

  const alcoholVolume = product?.wine?.chemicalAnalysis?.alcoholVolume
  const rs = product?.wine?.chemicalAnalysis?.residualSugar
  const ta = product?.wine?.chemicalAnalysis?.acidityTotal?.value
  const ph = product?.wine?.chemicalAnalysis?.pH
  const taUnit = product?.wine?.chemicalAnalysis?.acidityTotal?.unit?.masterName

  if (isAlcoholNull(alcoholVolume) && !rs && !ta && !ph) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.chemicalAnalisys')}</ItemLabel>
      <Wrapper>
        {!isAlcoholNull(alcoholVolume) && alcoholVolume >= 0 && (
          <Parameter>
            <Label>{t('wine.view.abv')}: </Label>
            <Value>{alcoholVolume}%</Value>
          </Parameter>
        )}
        {Boolean(rs) && (
          <Parameter>
            <Label>{t('wine.view.rs')}: </Label>
            <Value>{rs} g/l</Value>
          </Parameter>
        )}
        {Boolean(ta) && (
          <Parameter>
            <Label>{t('wine.view.ta')}: </Label>
            <Value>
              {ta} {taUnit || 'g/l'}
            </Value>
          </Parameter>
        )}
        {Boolean(ph) && (
          <Parameter>
            <Label>{t('wine.view.ph')}: </Label>
            <Value>{ph}</Value>
          </Parameter>
        )}
      </Wrapper>
    </Item>
  )
}

export default ChemicalAnalisys
